import { render } from "./OperationExecutivePromotionView.vue?vue&type=template&id=b1da5b58"
import script from "./OperationExecutivePromotionView.vue?vue&type=script&lang=js"
export * from "./OperationExecutivePromotionView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__